import React from 'react';
import { DivRadio } from './styles';
import Icon from '../Section/Icon';
import checked from '../../static/img/check.svg';

export type RadioProps = {
  children?: any;
  value: string;
  name: string;
  onChange?: (e: any) => void;
};

const Radio = ({ onChange, name, value, children }: RadioProps) => {
  return (
    <DivRadio>
      <input type="radio" name={name} onChange={onChange} value={value} />
      {children}
      <span>
        <Icon svg={checked} alt="checked" />
      </span>
    </DivRadio>
  );
};

export default Radio;
